import { createFileRoute } from '@tanstack/react-router';

import { getCompetitorQueryOptions } from '@/_pages/competitors/api-service';
import Loading from '@/_pages/competitors/profile/loading';

export const Route = createFileRoute('/_private/competitors/_template/$id/')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompetitorQueryOptions(opts.params.id)),
  staticData: {
    renderRightColumn: true,
    pageTitle: 'Competitor',
    tabKey: 'competitor/profile',
  },
  pendingComponent: Loading,
});
